import { render } from "./menu-bar.vue?vue&type=template&id=a57e1912"
import script from "./menu-bar.vue?vue&type=script&lang=js"
export * from "./menu-bar.vue?vue&type=script&lang=js"

import "./menu-bar.vue?vue&type=style&index=0&id=a57e1912&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__